import { Alert } from 'antd';

import { ApiError, NetworkError } from '@starling/core/api/errors';

interface ErrorAlertProps {
  error: unknown;
  /** Если задан — переопределяет сообщение, иначе берётся из ошибки. */
  fallbackMessage?: string;
}

// Универсальное отображение API-ошибок и сетевых сбоев.
// Все надписи приходят с сервера на русском (см. OpenAPI D5 — message локализована
// на стороне backend), поэтому в этом компоненте нет i18n-ключей.
export function ErrorAlert({ error, fallbackMessage }: ErrorAlertProps): JSX.Element | null {
  if (!error) return null;

  let message: string;
  let description: string | undefined;

  if (error instanceof ApiError) {
    message = error.message || fallbackMessage || `Ошибка ${error.status}`;
    description = error.code ? `Код: ${error.code}` : undefined;
  } else if (error instanceof NetworkError) {
    message = 'Сетевой сбой';
    description = 'Проверьте подключение и попробуйте снова.';
  } else if (error instanceof Error) {
    message = error.message || fallbackMessage || 'Неизвестная ошибка';
  } else {
    message = fallbackMessage || 'Неизвестная ошибка';
  }

  return <Alert type="error" showIcon message={message} description={description} />;
}
